import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CustomFormsModule} from 'ng2-validation';

import {PasswordValidatorModule} from '../../../shared/validators';
import {UserPasswordFormComponent} from './user-password-form.component';

@NgModule({
  declarations: [UserPasswordFormComponent],
  exports: [UserPasswordFormComponent],
  imports: [CommonModule, FormsModule, CustomFormsModule, PasswordValidatorModule],
})
export class UserPasswordFormModule {}



// WEBPACK FOOTER //
// ./src/app/user-management/user-password/user-password-form/user-password-form.module.ts